import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroCarousel from "../components/HeroCarousel";
import IndustriesExplorer from "../components/IndustriesExplorer";
import Reveal from "../components/Reveal";
import { businessUnits, company } from "../mock";

// Business units shown on the home page (Print & Promotion and Oil & Gas)
const homeUnits = businessUnits.filter((u) => [1, 2, 3].includes(u.id));

export default function Home() {
  return (
    <div>
      <HeroCarousel />

      {/* About / Get in touch */}
      <section className="py-24 bg-white">
        <div className="mx-auto max-w-[1000px] px-6 grid grid-cols-1 md:grid-cols-2 gap-16">
          <div className="text-center">
            <h2 className="font-heading text-3xl uppercase tracking-[0.12em] text-[#1a2540] mb-6">
              About MSV
            </h2>
            <div className="w-12 h-[3px] bg-[#1b75bc] mx-auto mb-6" />
            <p className="text-[#6a6a6a] leading-relaxed mb-8 max-w-sm mx-auto">
              {company.name} is a holding company with three independent business units.
            </p>
            <Link
              to="/about"
              className="inline-block font-heading uppercase tracking-[0.18em] text-sm text-[#1a2540] border border-[#1a2540] px-8 py-3 hover:bg-[#1a2540] hover:text-white transition-all duration-300"
            >
              Learn More
            </Link>
          </div>

          <div className="text-center">
            <h2 className="font-heading text-3xl uppercase tracking-[0.12em] text-[#1a2540] mb-6">
              Get In Touch
            </h2>
            <div className="w-12 h-[3px] bg-[#1b75bc] mx-auto mb-6" />
            <p className="text-[#6a6a6a] leading-relaxed mb-8 max-w-sm mx-auto">
              Start a conversation with Market Street Ventures. We would love to start working with you.
            </p>
            <Link
              to="/contact"
              className="inline-block font-heading uppercase tracking-[0.18em] text-sm text-[#1a2540] border border-[#1a2540] px-8 py-3 hover:bg-[#1a2540] hover:text-white transition-all duration-300"
            >
              Contact MSV
            </Link>
          </div>
        </div>
      </section>

      {/* Business Units */}
      <section className="py-24 msv-dot-bg">
        <div className="mx-auto max-w-[1240px] px-6">
          <Reveal className="text-center mb-16">
            <p className="msv-eyebrow mb-4">What We Do</p>
            <h2 className="font-heading text-4xl uppercase tracking-[0.08em] text-[#1a2540]">
              Our Business Units
            </h2>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {homeUnits.map((unit, i) => (
              <Reveal key={unit.id} delay={i * 80}>
              <div
                className="group msv-card h-full p-8 overflow-hidden"
              >
                <div className="absolute top-0 left-0 h-1 w-0 group-hover:w-full bg-gradient-to-r from-[#1b75bc] to-[#0f6b82] transition-all duration-500 rounded-t-2xl" />
                <span className="font-heading text-5xl font-light text-[#e2e8ee] group-hover:text-[#1b75bc]/40 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-heading text-xl uppercase tracking-[0.06em] text-[#1a2540] mt-3 mb-3">
                  {unit.short}
                </h3>
                <p className="text-sm text-[#6a6a6a] leading-relaxed">{unit.description}</p>
              </div>
              </Reveal>
            ))}
            <Reveal delay={homeUnits.length * 80}>
            <div className="relative h-full p-8 rounded-2xl overflow-hidden flex flex-col justify-center bg-gradient-to-br from-[#1a2540] to-[#0f2c4a] shadow-[0_20px_45px_-20px_rgba(15,41,74,0.6)]">
              <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-[#1b75bc]/20 blur-2xl" />
              <h3 className="relative font-heading text-2xl uppercase tracking-[0.06em] text-white mb-4">
                Let's Build Together
              </h3>
              <p className="relative text-sm text-gray-300 leading-relaxed mb-6">
                Discover how Market Street Ventures can support your business needs.
              </p>
              <Link
                to="/contact"
                className="relative inline-flex items-center gap-2 font-heading uppercase tracking-[0.18em] text-sm text-[#4aa3e0] hover:text-white transition-colors group/link"
              >
                Get Started <ArrowRight size={16} className="group-hover/link:translate-x-1 transition-transform" />
              </Link>
            </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Industries We Serve - interactive */}
      <IndustriesExplorer />

      {/* CTA band */}
      <section className="py-20 bg-[#0f6b82]">
        <div className="mx-auto max-w-[900px] px-6 text-center">
          <h2 className="font-heading text-3xl md:text-4xl uppercase tracking-[0.08em] text-white mb-5">
            Professional Solutions You Can Trust
          </h2>
          <p className="text-white/80 leading-relaxed mb-8 max-w-2xl mx-auto">
            From cleaning solutions and natural absorbents to commodities and consulting — we deliver
            quality, consistency and value across every business unit.
          </p>
          <Link
            to="/contact"
            className="inline-block font-heading uppercase tracking-[0.2em] text-sm text-white border border-white/70 px-10 py-4 hover:bg-white hover:text-[#0f6b82] transition-all duration-300"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}
